<template>
  <div class="vip-view">
    <div class="form-horizontal">
    <vip-info :user="user"></vip-info>
    <div class="form-group">
        <div class="col-sm-10 col-sm-offset-2">
          <button class="btn btn-primary" @click="gotoRecharge" v-show="user.profile.vipID!==null">充值</button>
          <button class="btn btn-primary" @click="saveUserInfo">保存</button>
        </div>
      </div>
    </div>
    <div class="panel panel-default">
      <div class="panel-heading">用户洗衣单</div>
          <div class="table-responsive">
          <table class="table">
            <thead>
              <tr>
                <th>序号</th>
                <th>衣单编号</th>
                <th>送衣时间</th>
                <th>取衣时间</th>                    
                <th>计划取衣时间</th>
                <th>是否支付</th>
                <th>是否取走</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in tickets" :key="index" @click="onRowClick(item)">
                <td>{{index+1}}</td>
                <td>{{item.idView}}</td>
                <td>{{item.createAt | dt }}</td>
                <td>{{item.realTakeAwayAt | dt }}</td>
                <td>{{item.planTakeAwayAt | dt}}</td>
                <td>{{item.hasPay ? '是' : '否'}}</td>
                <td>{{item.hasTakeOff ? '是' : '否'}}</td>
              </tr>
            </tbody>
          </table>
      </div>
    </div>
    <div class="panel panel-default">
      <div class="panel-heading">用户充值记录</div>
        <account-records :items="accountRecords"></account-records>
    </div>

  </div>
</template>

<script>
import VipInfo from '@/components/views/Vip'
import TicketList from '@/components/list/Tickets'
import AccountRecords from '@/components/list/AccountRecords'
import * as TYPES from '../store/types'
import apiClient from '../api'

export default {
  components: {
    VipInfo,
    TicketList,
    AccountRecords
  },
  data() {
    return {
      user: {},
      accountRecords: []
    }
  },
  computed: {
    tickets() {
      if (this.user.tickets) {
        return this.user.tickets.reverse()
      }
      return []
    }
  },
  created() {
    if (this.$route.params.phone) {
      apiClient.DO_USER_VIEW(this.$route.params.phone)
      .then(res => {
        if (res.data.ok) {
          this.user = res.data.data
          apiClient.DO_GET_ACCOUNT_RECORD_LIST(res.data.data.id)
          .then(r => {
            if (res.data.ok) {
              this.accountRecords = r.data.data
            }
          })
        }
      })
    }
  },
  methods: {
    saveUserInfo() {
      this.$confirm({
        title: '修改会员信息确认',
        content: '会员信息将会被修改，确认继续吗？'
      })
          .then(() => {
            this.$store.dispatch(TYPES.DO_UPDATE_USER_PROFILE, this.user)
            .then(res => {
              this.$notify({
                type: 'success',
                content: '会员信息修改成功！'
              })
            })
            .catch(res => {
              this.$notify({
                type: 'danger',
                content: '会员信息修改失败！'
              })
            })
          })
          .catch(() => {
            this.$notify('取消会员信息修改！')
          })
    },
    gotoRecharge() {
      this.$router.push('/recharge/' + this.user.profile.phone)
    },
    onRowClick(item) {
      this.$router.push('/ticket/' + item.idView)
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/pages/VipView.vue